import { render, staticRenderFns } from "./ApplicationSuccess.vue?vue&type=template&id=823b551a&"
import script from "./ApplicationSuccess.vue?vue&type=script&lang=js&"
export * from "./ApplicationSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports